export default __webpack_public_path__ + "static/media/linux.d3f19dc5.svg";